import { Col, Container, Row } from "react-bootstrap";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import BasicTable from "../Atomics/Table";
import { HeadingWrapper } from "../Atomics/SectionHeader/SectionHeader";
import DatePicker from "react-multi-date-picker";
import { useContext, useState } from "react";
import DateObject from "react-date-object";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import LoadingIndicator from "../Atomics/Loading/Loading";
import ThinFooter from "../Footer/ThinFooter";
import { commentsFetcher, pannelInfoFetcher } from "../../api/requests";
import { AuthContext } from "../../context/auth";

const CommentStatistics = () => {
  const [fromDate, setFromDate] = useState(
    new DateObject({ calendar: persian, locale: persian_fa }).subtract(7, "day")
  );
  const [toDate, setToDate] = useState(
    new DateObject({ calendar: persian, locale: persian_fa }).add(1, "day")
  );
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const { user } = useContext(AuthContext);

  const handleDateRangeFilter = () => {
    getFilteredData();
  };

  const convertToEnglishDigits = (persianDate) => {
    if (!persianDate) return null;

    return persianDate.replace(/[۰-۹]/g, (digit) =>
      "۰۱۲۳۴۵۶۷۸۹".indexOf(digit)
    );
  };

  const getFilteredData = async () => {
    setLoading(true);
    try {
      const res = await pannelInfoFetcher.getComments(
        convertToEnglishDigits(fromDate.format("YYYY-MM-DD")),
        convertToEnglishDigits(toDate.format("YYYY-MM-DD")),
        user.user_id
      );
      setFilteredData(res);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContentWrapper>
      <Container
        fluid
        className="upload-details text-right"
        style={{
          paddingLeft: "30px",
          paddingRight: "30px",
          minHeight: "calc(100vh - 123px)",
        }}
      >
        <div
          style={{
            paddingTop: "30px",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <Row>
            <Col>
              <div className="float-right">
                <HeadingWrapper heading="گزارش گیری نظرات" />
              </div>
            </Col>
          </Row>

          <Row className="p-3" style={{ gap: "8px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span>از</span>
              <DatePicker
                value={fromDate}
                onChange={setFromDate}
                calendar={persian}
                locale={persian_fa}
                placeholder="تاریخ شروع"
                className="teal"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "8px",
                  width: "100%",
                }}
              />
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span>تا</span>
              <DatePicker
                value={toDate}
                onChange={setToDate}
                calendar={persian}
                locale={persian_fa}
                placeholder="تاریخ پایان"
                className="teal"
                style={{
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  padding: "8px",
                  width: "100%",
                }}
              />
            </div>

            <div>
              <button
                className="btn btn-primary py-0"
                onClick={handleDateRangeFilter}
                style={{ width: "100%", fontSize: "14px" }}
              >
                فیلتر
              </button>
            </div>
          </Row>

          <Row className="py-3">
            <Col>
              {loading ? (
                <LoadingIndicator />
              ) : filteredData.length > 0 ? (
                <>
                  <BasicTable
                    name="commentStatistics"
                    cols={[
                      "نام کانال",
                      "نام ویدئو",
                      "تعداد کامنت ها",
                      "تعداد تایید شده",
                      "تعداد تایید نشده",
                      // "مدیریت نظرات"
                    ]}
                    rows={filteredData}
                  />
                </>
              ) : (
                <p>داده ای در این تاریخ وارد نشده است.</p>
              )}
            </Col>
          </Row>
        </div>
      </Container>

      <ThinFooter />
    </ContentWrapper>
  );
};

export default CommentStatistics;
